import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#883365"
					title={"Bunbury Central"}
					image={require('./video.jpg')}
					video={{ mp4: require('./video.mp4'), webm: require('./video.webm')}}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A custom designed platfrom to promote the centre of Bunbury</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/bunbury-central.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi worked with the Bunbury Central committee to develop a directory that is easy and fun to use. The combination of off-centre design, flowing animation and video creates an interactive experience contrasted against the static form of most websites.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Brand development</li>
									<li>Website <a href="https://www.bunburycentral.com.au" target="_blank">www.bunburycentral.com.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Video banner to grab attention</li>
									<li>Animated elements for smooth flow</li>
									<li>Google Adwords Advertising Campaign</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/BunburyCentral/index.js